
<app-summary-employer-details> </app-summary-employer-details>
<app-summary-form2b *ngIf="this.claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_EC_FORM2B') !== -1"></app-summary-form2b>
<app-summary-form2a *ngIf="this.claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_EC_FORM2A') !== -1"></app-summary-form2a>
<app-summary-form2 *ngIf="this.claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_EC_FORM2') !== -1"></app-summary-form2>
